import { render, staticRenderFns } from "./AddSupportTicket.vue?vue&type=template&id=06ae50f0&scoped=true&"
import script from "./AddSupportTicket.vue?vue&type=script&lang=js&"
export * from "./AddSupportTicket.vue?vue&type=script&lang=js&"
import style0 from "./AddSupportTicket.vue?vue&type=style&index=0&id=06ae50f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ae50f0",
  null
  
)

export default component.exports